import { createSlice } from '@reduxjs/toolkit';
import { fetchStatuses } from './actions';

const initialState = {
  list: [],
  isLoading: false,
  error: null,
  hasLoaded: false,
  requestedComplaintTypeId: null,
};

const unwrapStatuses = (payload) => {
  const data = payload?.data ?? payload?.results ?? payload?.items ?? payload;
  return Array.isArray(data) ? data : [];
};

const errorMessage = (action) =>
  action.payload?.message ?? action.error?.message ?? 'Failed to fetch statuses';

const statusSlice = createSlice({
  name: 'status',
  initialState,
  reducers: {
    // Unused: nothing dispatches this helper.
    // clearStatusError: (state) => {
    //   state.error = null;
    // },
    resetStatusState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStatuses.pending, (state, action) => {
        state.isLoading = true;
        state.error = null;
        state.hasLoaded = false;
        state.list = [];
        state.requestedComplaintTypeId = action.meta.arg ?? null;
      })
      .addCase(fetchStatuses.fulfilled, (state, action) => {
        const requestedId = action.meta.arg;
        if (
          state.requestedComplaintTypeId != null &&
          requestedId != null &&
          String(state.requestedComplaintTypeId) !== String(requestedId)
        ) {
          return;
        }
        const list = unwrapStatuses(action.payload);
        state.isLoading = false;
        state.hasLoaded = true;
        state.list = [...list].sort(
          (left, right) => (left.displayOrder ?? 0) - (right.displayOrder ?? 0),
        );
      })
      .addCase(fetchStatuses.rejected, (state, action) => {
        if (action.meta.aborted) return;
        const requestedId = action.meta.arg;
        if (
          state.requestedComplaintTypeId != null &&
          requestedId != null &&
          String(state.requestedComplaintTypeId) !== String(requestedId)
        ) {
          return;
        }
        state.isLoading = false;
        state.hasLoaded = true;
        state.error = errorMessage(action);
      });
  },
});

export const {
  // clearStatusError,
  resetStatusState,
} = statusSlice.actions;
export default statusSlice.reducer;
